import type { BattleItem } from "./types";

const battleItems: BattleItem[] = [
  { id: "potion", image: "battle-items/potion.png", name: "Potion" },
  { id: "x-attack", image: "battle-items/x-attack.png", name: "X Attack" },
  { id: "x-speed", image: "battle-items/x-speed.png", name: "X Speed" },
  { id: "fluffy-tail", image: "battle-items/fluffy-tail.png", name: "Fluffy Tail" },
  { id: "eject-button", image: "battle-items/eject-button.png", name: "Eject Button" },
  { id: "slow-smoke", image: "battle-items/slow-smoke.png", name: "Slow Smoke" },
  { id: "full-heal", image: "battle-items/full-heal.png", name: "Full Heal" },
  { id: "goal-getter", image: "battle-items/goal-getter.png", name: "Goal-Getter" },
  { id: "shedinja-doll", image: "battle-items/shedinja-doll.png", name: "Shedinja Doll" },
  { id: "goal-hacker", image: "battle-items/goal-hacker.png", name: "Goal Hacker" },
];

export default battleItems;
